module.exports = {
	"pagination": {
		"ListJobsByPipeline": {
			"input_token": "PageToken",
			"output_token": "NextPageToken",
			"result_key": "Jobs"
		},
		"ListJobsByStatus": {
			"input_token": "PageToken",
			"output_token": "NextPageToken",
			"result_key": "Jobs"
		},
		"ListPipelines": {
			"input_token": "PageToken",
			"output_token": "NextPageToken",
			"result_key": "Pipelines"
		},
		"ListPresets": {
			"input_token": "PageToken",
			"output_token": "NextPageToken",
			"result_key": "Presets"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/elastictranscoder-2012-09-25.paginators.json
// module id = 649
// module chunks = 0